export default "__VITE_ASSET__CZ94eh$3__"